<template>
  <section class="d-table mx-auto col-md-10 mb-4 text-center" style="margin-top:-3rem">
    <div class="d-table mx-auto">
      <h2 class="font-heading-1 font-family-concended font-all-upper">Thank you!</h2>
      <div class="underlined darkgreen mb-3"></div>
    </div>
    <h2 v-if="$store.state.userExist === 0"
      class="font-heading-2 font-family-bold mt-4"
    >The form was submitted successfully! Keep an eye on your inbox and you will receive an email and an activation link.</h2>
    <h2 v-if="$store.state.userExist === 1"
      class="font-heading-2 font-family-bold mt-4"
    ><p class="font-heading-2 font-family-bold">We noticed you have already registered with Starbucks Coffee Academy. No problem! Any new courses you selected will be added to your account.</p>
    <p class="font-heading-2 font-family-bold"> Click the link below to sign into Starbucks Global Academy and continue learning or reset your password.</p>
    <a href="https://courses.starbucksglobalacademy.com/login" class="link-click font-heading-2 font-family-bold" target="_blank">Starbucks Global Academy</a></h2>
    <form id="success-form"></form>
  </section>
</template>

<script>
export default {
  name: "SuccessComponent"
};
</script>
<style>
#success-form {
  display: none;
}
</style>

